/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ThoughtspotToken
 */
export interface ThoughtspotToken {
    /**
     * 
     * @type {string}
     * @memberof ThoughtspotToken
     */
    token: string;
}

/**
 * Check if a given object implements the ThoughtspotToken interface.
 */
export function instanceOfThoughtspotToken(value: object): value is ThoughtspotToken {
    if (!('token' in value) || value['token'] === undefined) return false;
    return true;
}

export function ThoughtspotTokenFromJSON(json: any): ThoughtspotToken {
    return ThoughtspotTokenFromJSONTyped(json, false);
}

export function ThoughtspotTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): ThoughtspotToken {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
    };
}

export function ThoughtspotTokenToJSON(json: any): ThoughtspotToken {
    return ThoughtspotTokenToJSONTyped(json, false);
}

export function ThoughtspotTokenToJSONTyped(value?: ThoughtspotToken | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
    };
}

